module.exports = __webpack_public_path__ + "img/logo.bf4a9a78.png";